/**
 * ZeoContextBar - dauerhafte Kontextzeile oben im /zeo-Chat:
 *   Klient: [Name]   Aufgabe: [Titel/keine]   (Vorgang: [..])   (Dokument: [..])
 * Controls: [Klient wechseln] [Aufgabe wechseln] [+ Neue Aufgabe]
 * Zeigt NIE interne IDs. Klient wechseln = ausdruecklich NEUER Chat (Cross-Context-Schutz bleibt serverseitig).
 */
import { Users, ListChecks, Plus } from 'lucide-react';
import { kontextBarZeilen, kannAufgabeWaehlen } from './zeoWorkspace';

export default function ZeoContextBar({ kontext, onKlientWechseln, onAufgabeWechseln, onNeueAufgabe }) {
  const zeilen = kontextBarZeilen(kontext);
  const aufgabeMoeglich = kannAufgabeWaehlen(kontext);

  return (
    <div className="shrink-0 flex flex-wrap items-center gap-x-5 gap-y-2 px-5 py-2 border-b border-violet-100 bg-violet-50/40" data-testid="zeo-context-bar">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 min-w-0">
        {zeilen.map((z) => (
          <span key={z.key} className="text-xs text-slate-500 truncate max-w-[18rem]" data-testid={`zeo-context-${z.key}`}>
            <span className="text-slate-400">{z.label}:</span>{' '}
            <span className="font-medium text-slate-800">{z.wert}</span>
          </span>
        ))}
      </div>
      <div className="ml-auto flex items-center gap-2">
        <button type="button" onClick={onKlientWechseln} data-testid="zeo-context-klient-wechseln"
          className="text-xs px-2.5 py-1.5 rounded-lg bg-white border border-violet-100 text-slate-600 hover:bg-violet-50 flex items-center gap-1">
          <Users size={13} /> Klient wechseln
        </button>
        <button type="button" onClick={onAufgabeWechseln} disabled={!aufgabeMoeglich} data-testid="zeo-context-aufgabe-wechseln"
          title={aufgabeMoeglich ? '' : 'Zuerst einen Klienten wählen'}
          className="text-xs px-2.5 py-1.5 rounded-lg bg-white border border-violet-100 text-slate-600 hover:bg-violet-50 flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed">
          <ListChecks size={13} /> Aufgabe wechseln
        </button>
        <button type="button" onClick={onNeueAufgabe} disabled={!aufgabeMoeglich} data-testid="zeo-context-neue-aufgabe"
          title={aufgabeMoeglich ? '' : 'Zuerst einen Klienten wählen'}
          className="text-xs px-2.5 py-1.5 rounded-lg bg-violet-600 text-white hover:bg-violet-700 flex items-center gap-1 disabled:opacity-40 disabled:cursor-not-allowed">
          <Plus size={13} /> Neue Aufgabe
        </button>
      </div>
    </div>
  );
}
